module.exports = __webpack_public_path__ + "img/home-or-right-ad.bb92e120.jpg";